const SEPARATOR_PATTERN = /[\s._-]+/;
const CHINESE_CHAR_PATTERN = /[\p{Script=Han}]/u;
const CHINESE_CHARS_GLOBAL = /[\p{Script=Han}]/gu;
const CAMEL_BOUNDARY_PATTERN = /([a-z0-9])([A-Z])/g;
const PURE_LOWERCASE_PATTERN = /^[a-z]+$/;
const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+$/;

function firstChar(value: string) {
  return Array.from(value)[0] ?? "";
}

function normalizeChars(value: string) {
  return Array.from(value.replace(/\s+/g, ""));
}

function normalizeInitial(char: string) {
  if (/^[a-z]$/i.test(char)) {
    return char.toUpperCase();
  }
  return char;
}

function initialsFromParts(parts: string[]) {
  const initials = parts
    .map((part) => firstChar(part))
    .filter(Boolean)
    .slice(0, 2)
    .map(normalizeInitial)
    .join("");

  return initials || "?";
}

function splitCamelCase(value: string) {
  return value
    .replace(CAMEL_BOUNDARY_PATTERN, "$1 $2")
    .split(/\s+/)
    .filter(Boolean);
}

function extractChineseInitials(value: string) {
  const chars = Array.from(
    value.matchAll(CHINESE_CHARS_GLOBAL),
    (match) => match[0],
  );
  if (chars.length === 0) return "";
  if (chars.length === 1) return chars[0];
  return `${chars[0]}${chars[1]}`;
}

function extractLowercaseConcatenated(value: string) {
  return value.slice(0, 2).toUpperCase();
}

function stripEmailDomain(value: string) {
  if (!EMAIL_PATTERN.test(value) || !value.includes("@")) return value;
  const [localPart] = value.split("@");
  return localPart || value;
}

export function getAvatarInitials(nickname: unknown) {
  const rawValue = nickname == null ? "" : String(nickname).trim();
  if (!rawValue) return "";

  const source = stripEmailDomain(rawValue);

  const separatorParts = source.split(SEPARATOR_PATTERN).filter(Boolean);
  if (separatorParts.length > 1) {
    return initialsFromParts(separatorParts);
  }

  const camelParts = splitCamelCase(source);
  if (camelParts.length > 1) {
    return initialsFromParts(camelParts);
  }

  if (CHINESE_CHAR_PATTERN.test(source)) {
    return extractChineseInitials(source);
  }

  if (PURE_LOWERCASE_PATTERN.test(source)) {
    return extractLowercaseConcatenated(source);
  }

  const visibleChars = normalizeChars(source)
    .slice(0, 2)
    .map(normalizeInitial)
    .join("");
  return visibleChars || "?";
}
